import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/features/auth'
import { getFirstName } from '../home.logic'
import type { OngoingProject } from '../types/home.types'

interface GreetingSectionProps {
  ongoingProjects: OngoingProject[]
}

export function GreetingSection({ ongoingProjects }: GreetingSectionProps) {
  const { t } = useTranslation()
  const user = useAuthStore((s) => s.user)
  const firstName = user ? getFirstName(user.fullName) : ''

  // Get greeting based on current hour
  const hour = new Date().getHours()
  let greetingKey = 'greeting.evening'
  if (hour < 12) greetingKey = 'greeting.morning'
  else if (hour < 17) greetingKey = 'greeting.afternoon'

  const urgentCount = ongoingProjects.filter((p) => p.urgent).length

  return (
    <section className="mb-6" aria-labelledby="greeting-heading">
      <h1 id="greeting-heading" className="text-foreground text-2xl font-bold">
        {t(greetingKey)}, {firstName}
      </h1>
      <p className="text-muted-foreground mt-1 text-sm">
        {t('home.projectsCount', { count: ongoingProjects.length })}
        {urgentCount > 0 && (
          <span
            className="ml-2 inline-flex items-center rounded-full border border-[var(--badge-urgent-border)] bg-[var(--badge-urgent-bg)] px-2 py-0.5 text-xs font-bold text-[var(--badge-urgent-text)]"
            role="status"
            aria-label={t('home.urgentProjects', { count: urgentCount })}
          >
            <span aria-hidden="true">⚠</span> {t('home.urgentProjects', { count: urgentCount })}
          </span>
        )}
      </p>
    </section>
  )
}
